var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 619,
    height: 300,
    viewBox: "0 0 619 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2052_5006)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 197.735,
    y1: 136.432,
    x2: 197.735,
    y2: 200.752,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("line", {
    x1: 224.96,
    y1: 184.27,
    x2: 198.16,
    y2: 205.573,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.498,
    y1: 184.996,
    x2: 197.274,
    y2: 203.545,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.687,
    y1: 138.267,
    x2: 131.367,
    y2: 256.187,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.015 136.4L264.361 258.319",
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132.466,
    y1: 257.909,
    x2: 199.26,
    y2: 195.843,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.461,
    y1: 195.841,
    x2: 262.254,
    y2: 257.908,
    stroke: "#427BF1",
    strokeWidth: 2.29061
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.04,
    cy: 252.96,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.357,
    cy: 199.36,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 197.357,
    cy: 135.04,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.56,
    cy: 183.28,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.161,
    cy: 183.28,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 261.681,
    cy: 252.96,
    r: 8.03999,
    fill: "#427BF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.406 202.948H275.659L271.063 216H260.125L283.012 152.027H295.145L318.032 216H307.002L302.406 202.948ZM299.465 194.4L289.078 164.711L278.6 194.4H299.465ZM333.314 158.645C331.414 158.645 329.821 158.002 328.534 156.715C327.248 155.428 326.604 153.835 326.604 151.935C326.604 150.036 327.248 148.442 328.534 147.156C329.821 145.869 331.414 145.225 333.314 145.225C335.152 145.225 336.715 145.869 338.002 147.156C339.288 148.442 339.932 150.036 339.932 151.935C339.932 153.835 339.288 155.428 338.002 156.715C336.715 158.002 335.152 158.645 333.314 158.645ZM338.461 165.355V216H327.983V165.355H338.461ZM362.697 172.708C364.229 170.134 366.251 168.143 368.763 166.734C371.337 165.263 374.37 164.528 377.863 164.528V175.374H375.197C371.092 175.374 367.966 176.415 365.822 178.499C363.738 180.582 362.697 184.197 362.697 189.345V216H352.218V165.355H362.697V172.708ZM397.973 160.575V179.326H420.032V187.874H397.973V207.452H422.79V216H387.494V152.027H422.79V160.575H397.973ZM432.203 190.448C432.203 185.362 433.245 180.858 435.328 176.936C437.473 173.014 440.353 169.981 443.968 167.836C447.645 165.631 451.72 164.528 456.193 164.528C459.502 164.528 462.75 165.263 465.936 166.734C469.184 168.143 471.757 170.042 473.657 172.432V147.983H484.227V216H473.657V208.371C471.941 210.822 469.551 212.844 466.487 214.437C463.485 216.031 460.023 216.827 456.101 216.827C451.689 216.827 447.645 215.724 443.968 213.518C440.353 211.251 437.473 208.126 435.328 204.143C433.245 200.099 432.203 195.534 432.203 190.448ZM473.657 190.631C473.657 187.139 472.921 184.105 471.451 181.532C470.041 178.958 468.172 176.997 465.844 175.649C463.515 174.301 461.003 173.627 458.307 173.627C455.611 173.627 453.098 174.301 450.77 175.649C448.441 176.936 446.542 178.866 445.071 181.44C443.662 183.952 442.957 186.955 442.957 190.448C442.957 193.94 443.662 197.004 445.071 199.639C446.542 202.274 448.441 204.296 450.77 205.706C453.16 207.054 455.672 207.728 458.307 207.728C461.003 207.728 463.515 207.054 465.844 205.706C468.172 204.357 470.041 202.397 471.451 199.823C472.921 197.188 473.657 194.124 473.657 190.631ZM503.321 158.645C501.421 158.645 499.828 158.002 498.541 156.715C497.255 155.428 496.611 153.835 496.611 151.935C496.611 150.036 497.255 148.442 498.541 147.156C499.828 145.869 501.421 145.225 503.321 145.225C505.159 145.225 506.722 145.869 508.009 147.156C509.295 148.442 509.939 150.036 509.939 151.935C509.939 153.835 509.295 155.428 508.009 156.715C506.722 158.002 505.159 158.645 503.321 158.645ZM508.468 165.355V216H497.99V165.355H508.468ZM543.458 173.903H534.082V216H523.512V173.903H517.538V165.355H523.512V161.77C523.512 155.949 525.044 151.721 528.108 149.086C531.233 146.39 536.104 145.042 542.722 145.042V153.773C539.536 153.773 537.299 154.386 536.013 155.612C534.726 156.776 534.082 158.829 534.082 161.77V165.355H543.458V173.903ZM598.334 165.355L567.267 239.806H556.421L566.715 215.173L546.769 165.355H558.443L572.69 203.959L587.488 165.355H598.334Z",
    fill: "#427BF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2052_5006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 619,
    height: 300,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.13949e1f3b077dee4a07ce02762b20ff.svg";
export { ForwardRef as ReactComponent };